import config from '../../../config'
import http from './http-util'

const createStatisticsRequestBody = ({
  start: from,
  end: to,
  period: periodType,
  filters = [],
  userId,
  customStart,
}) =>
  JSON.stringify({
    ...((customStart && { from }) || {}),
    to,
    periodType,
    ...((userId && { userId }) || {}),
    ...((filters && {
      filters: filters.map(({ field, type, value }) => ({
        field,
        type,
        value,
      })),
    }) ||
      {}),
  })

class StatsApi {
  static getSalesPersonAmountStats = ({ scope, ...req }, token) => {
    const url =
      scope === 'store'
        ? `${config.paymentEngineStatsUrl}/statistics/store/sales_summation`
        : `${config.paymentEngineStatsUrl}/statistics/representative/sales_summation`

    return http.post(token, url, createStatisticsRequestBody(req))
  }

  static getTopSellers = ({ scope, ...req }, token) => {
    const url =
      scope === 'store'
        ? `${config.paymentEngineStatsUrl}/statistics/store/top_salesmen`
        : `${config.paymentEngineStatsUrl}/statistics/representative/top_stores`

    return http.post(token, url, createStatisticsRequestBody(req))
  }

  static getTrend = ({ scope, ...req }, token) => {
    const url =
      scope === 'store'
        ? `${config.paymentEngineStatsUrl}/statistics/store/sales_trends`
        : `${config.paymentEngineStatsUrl}/statistics/representative/sales_trends`

    return http.post(token, url, createStatisticsRequestBody(req))
  }

  static getGender = ({ scope, ...req }, token) => {
    const url =
      scope === 'store'
        ? `${config.paymentEngineStatsUrl}/statistics/store/sales_by_gender`
        : `${config.paymentEngineStatsUrl}/statistics/representative/sales_by_gender`

    return http.post(token, url, createStatisticsRequestBody(req))
  }

  static getSalesByPaymentMethods = ({ scope, ...req }, token) => {
    const url =
      scope === 'store'
        ? `${config.paymentEngineStatsUrl}/statistics/store/sales_by_payment_method`
        : `${config.paymentEngineStatsUrl}/statistics/representative/sales_by_payment_method`

    return http.post(token, url, createStatisticsRequestBody(req))
  }

  static getSalesByChannel = ({ scope, ...req }, token) => {
    const url =
      scope === 'store'
        ? `${config.paymentEngineStatsUrl}/statistics/store/sales_by_channel`
        : `${config.paymentEngineStatsUrl}/statistics/representative/sales_by_channel`

    return http.post(token, url, createStatisticsRequestBody(req))
  }

  static getSalesType = ({ scope, ...req }, token) => {
    const url =
      scope === 'store'
        ? `${config.paymentEngineStatsUrl}/statistics/store/sales_by_purchase_type`
        : `${config.paymentEngineStatsUrl}/statistics/representative/sales_by_purchase_type`

    return http.post(token, url, createStatisticsRequestBody(req))
  }
}

export default StatsApi
